"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

var _ConditionalWrapper = _interopRequireDefault(require("@micado-digital/react-ui/components/ConditionalWrapper"));

var _react2 = require("swiper/react");

require("swiper/css");

require("swiper/css/pagination");

var _Button = _interopRequireDefault(require("./Button"));

var _ReactTeaserList = _interopRequireDefault(require("./ReactTeaserList01.styles"));

var _swiper = require("swiper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ReactTeaserList01 = function ReactTeaserList01(_ref) {
  var autoplay = _ref.autoplay,
      button = _ref.button,
      children = _ref.children,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 3000 : _ref$delay,
      gridBreakpoints = _ref.gridBreakpoints,
      headline = _ref.headline,
      _ref$headlineVariant = _ref.headlineVariant,
      headlineVariant = _ref$headlineVariant === void 0 ? "h4" : _ref$headlineVariant,
      id = _ref.id,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      navNext = _ref.navNext,
      navPrev = _ref.navPrev,
      showNavigation = _ref.showNavigation,
      showPagination = _ref.showPagination,
      sliderBreakpoints = _ref.sliderBreakpoints,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 300 : _ref$speed,
      text = _ref.text,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      _ref$wrapNavigation = _ref.wrapNavigation,
      wrapNavigation = _ref$wrapNavigation === void 0 ? false : _ref$wrapNavigation,
      SwiperProps = _ref.SwiperProps;
  var css = (0, _ReactTeaserList.default)();

  if (!id) {
    id = Date.now();
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)("mco-teaser-list-01 mco-teaser-list-01--" + variant, css.root)
  }, (headline || button) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-teaser-list-01__textbox", css.textBox)
  }, headline && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "textPrimary",
    className: "mco-teaser-list-01__headline",
    dangerouslySetInnerHTML: {
      __html: headline
    },
    variant: headlineVariant,
    component: "h2"
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-teaser-list-01__text",
    dangerouslySetInnerHTML: {
      __html: text
    },
    variant: "body2",
    component: "p"
  }), button && (button === null || button === void 0 ? void 0 : button.link) && (button === null || button === void 0 ? void 0 : button.position) !== "bottom" && /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-teaser-list-01__button"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: button === null || button === void 0 ? void 0 : button.label,
    link: button === null || button === void 0 ? void 0 : button.link,
    target: button === null || button === void 0 ? void 0 : button.linkTarget,
    icon: (button === null || button === void 0 ? void 0 : button.icon) && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      src: button === null || button === void 0 ? void 0 : button.icon,
      size: button === null || button === void 0 ? void 0 : button.iconSize
    }),
    color: button !== null && button !== void 0 && button.color ? button === null || button === void 0 ? void 0 : button.color : "primary",
    variant: button !== null && button !== void 0 && button.variant ? button === null || button === void 0 ? void 0 : button.variant : "outlined",
    size: button !== null && button !== void 0 && button.size ? button === null || button === void 0 ? void 0 : button.size : "medium"
  }))), variant === "slider" ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.swiperRoot, "mco-teaser-list-01__swiperRoot")
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({
    autoplay: autoplay ? {
      delay: delay,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    } : false,
    breakpoints: sliderBreakpoints,
    className: (0, _clsx.default)(css.swiper, "mco-teaser-list-01-swiper", "swiper-container"),
    grabCursor: true,
    loop: loop,
    modules: [_swiper.Autoplay, _swiper.Pagination, _swiper.Navigation],
    navigation: showNavigation ? {
      nextEl: navNext ? ".swiper-button-next--".concat(id) : undefined,
      prevEl: navPrev ? ".swiper-button-prev--".concat(id) : undefined
    } : false,
    observer: true,
    observeParents: true,
    pagination: showPagination ? {
      el: ".swiper-pagination--".concat(id),
      clickable: true
    } : false,
    slidesPerView: 3,
    spaceBetween: spacing,
    speed: speed,
    watchOverflow: true
  }, SwiperProps), children.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: item.key
    }, item);
  })), showNavigation && /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: wrapNavigation,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "swiper-navigation-wrapper"
      }, children);
    }
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, navPrev && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("swiper-button-prev", "swiper-button-prev--".concat(id), css.swiperNav)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: navPrev,
    size: 40
  })), navNext && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("swiper-button-next", "swiper-button-next--".concat(id), css.swiperNav)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: navNext,
    size: 40
  })))), showPagination && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("swiper-pagination", "swiper-pagination--".concat(id), css.swiperPagination)
  })) : /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: spacing
  }, children.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
      item: true
    }, gridBreakpoints, {
      key: item.key
    }), item);
  })), button && (button === null || button === void 0 ? void 0 : button.link) && (button === null || button === void 0 ? void 0 : button.position) === "bottom" && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-teaser-list-01__button--bottom", css.buttonBottom)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: button === null || button === void 0 ? void 0 : button.label,
    link: button === null || button === void 0 ? void 0 : button.link,
    target: button === null || button === void 0 ? void 0 : button.linkTarget,
    icon: (button === null || button === void 0 ? void 0 : button.icon) && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      src: button === null || button === void 0 ? void 0 : button.icon,
      size: 10
    }),
    color: button !== null && button !== void 0 && button.color ? button === null || button === void 0 ? void 0 : button.color : "primary",
    variant: button !== null && button !== void 0 && button.variant ? button === null || button === void 0 ? void 0 : button.variant : "outlined",
    size: button !== null && button !== void 0 && button.size ? button === null || button === void 0 ? void 0 : button.size : "medium"
  })));
};

ReactTeaserList01.propTypes = {
  autoplay: _propTypes.default.bool,
  button: _propTypes.default.object,
  children: _propTypes.default.array.isRequired,
  delay: _propTypes.default.number,
  gridBreakpoints: _propTypes.default.object,
  headline: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  loop: _propTypes.default.bool,
  navNext: _propTypes.default.string,
  navPrev: _propTypes.default.string,
  spacing: _propTypes.default.number,
  speed: _propTypes.default.number,
  showNavigation: _propTypes.default.bool,
  showPagination: _propTypes.default.bool,
  sliderBreakpoints: _propTypes.default.object,
  SwiperProps: _propTypes.default.object,
  variant: _propTypes.default.string
};
var _default = ReactTeaserList01;
exports.default = _default;